import {
  faBatteryHalf,
  faBell,
  faBicycle, faBiking, faBox, faBoxes, faCalendarCheck, faChargingStation, faChartPie,
  faColumns, faDollarSign, faFighterJet, faGlobe, faHandHoldingUsd, faHelicopter,
  faHistory,
  faHourglassEnd, faLanguage, faMapMarkedAlt, faMapPin, faMapSigns, faPhone, faAd,
  faQrcode, faRunning, faSms, faTags, faUserAlt,
  faUsers,
  faWallet,
  faNewspaper,
  faPaperclip, faBook,
  faBuilding, faCarBattery, faListUl, faListAlt,
} from "@fortawesome/free-solid-svg-icons";
import ADMIN_ROLES from "../../data/admin-roles";

const menuItems = [
  {
    title: "Dashboard",
    url: "dashboard",
    icon: faColumns
  },
  {
    title: "Users",
    url: "users",
    icon: faUsers
  },
  {
    title: "Finances",
    url: "#",
    icon: faDollarSign,
    items: [
      {
        title: "Wallet",
        url: "wallet",
        icon: faWallet
      },
      {
        title: "Transactions",
        url: "transactions",
        icon: faHistory
      },
      {
        title: "Promo Codes",
        url: "promo-codes",
        icon: faAd,
      },
    ]
  },
  {
    title: "Bikes",
    url: "#",
    icon: faBicycle,
    items: [
      {
        title: "Bikes",
        url: "bikes",
        icon: faBicycle
      },
      {
        title: "Bike/User Triggers",
        url: "bike-scan-trigger",
        icon: faQrcode
      },
      {
        title: "Triggers History",
        url: "bike-trigger-history",
        icon: faHourglassEnd
      },
      {
        title: "Bikes History",
        url: "bikes-history",
        icon: faBiking
      },
      {
        title: "Hot Map",
        url: "bikes/hotMap",
        icon: faMapMarkedAlt
      },
      {
        title: "Police",
        url: "bikes/police",
        icon: faHelicopter
      },
      {
        title: "Bike Active Trips",
        url: "trip-active",
        icon: faBiking,
      },
      {
        title: "Package",
        url: "package",
        icon: faBoxes
      },
      {
        title: "Tariff",
        url: "tariff",
        icon: faHandHoldingUsd
      },
      {
        title: "Zoning",
        url: "zoning",
        icon: faMapPin
      },
    ],
  },
  {
    title: "Scooters",
    url: "#",
    icon: faFighterJet,
    items: [
      {
        title: "Scooters Dashboard",
        url: "dashboard-scooter",
        icon: faColumns,
      },
      {
        title: "Scooters",
        url: "scooter/scooter",
        icon: faFighterJet,
      },
      {
        title: "Scooter Map",
        url: "scooter/scooter/hot-map",
        icon: faMapMarkedAlt
      },
      {
        title: "Scooter History",
        url: "scooter/scooter/history",
        icon: faHistory
      },
      {
        title: "Batteries",
        url: "scooter/battery",
        icon: faBatteryHalf,
      },
      {
        title: "Batteries History",
        url: "scooter/battery-history",
        icon: faChargingStation,
      },
      {
        title: "Scooter Active Trips",
        url: "scooter/trip-active",
        icon: faRunning,
      },
      {
        title: "Scooter Zones",
        url: "scooter/zones",
        icon: faMapPin,
      },
      {
        title: "Parking",
        url: "scooter/parking",
        icon: faMapSigns,
      },
    ]
  },
  {
    title: "Chargers",
    url: "#",
    icon: faCarBattery,
    items: [
      {
        title: "PB History",
        url: "chargers/history",
        icon: faListUl,
      },
      {
        title: "PB active rents",
        url: "chargers/activeRents",
        icon: faRunning,
      },
      {
        title: "PB rents",
        url: "chargers/rents",
        icon: faHistory,
      },
      {
        title: "Chargers Stations Map",
        url: "chargers/stations/map",
        icon: faBuilding
      },
      {
        title: "Chargers Stations List",
        url: "chargers/stations/list",
        icon: faListAlt
      },
      {
        title: "Chargers Packages",
        url: "chargers/packages",
        icon: faBoxes
      },
      {
        title: "Chargers Tariff",
        url: "chargers/tariff",
        icon: faHandHoldingUsd
      },
    ]
  },

  {
    title: "Languages",
    url: "#",
    icon: faLanguage,
    items: [
      {
        title: "Translation",
        url: "translation",
        icon: faGlobe
      },
      {
        title: "Languages",
        url: "language",
        icon: faLanguage
      },
      {
        title: "Module",
        url: "module",
        icon: faBox
      },
      {
        title: "Notification Templates",
        url: "notificationTemplates",
        icon: faSms
      },
    ]
  },

  {
    title: "Admins",
    url: "admin",
    icon: faUserAlt,
    roles: ADMIN_ROLES.admin
  },
  {
    title: "Tags",
    url: "tag",
    icon: faTags
  },
  {
    title: "Alerts",
    url: "alerts",
    icon: faBell
  },
  {
    title: "Festive Days",
    url: "festive-days",
    icon: faCalendarCheck
  },
  {
    title: "Reports",
    url: "reports",
    icon: faChartPie,
    roles: ADMIN_ROLES.admin
  },
  {
    title: "Phone Codes",
    url: "phone-codes",
    icon: faPhone,
  },
  {
    title: "News",
    url: "news",
    icon: faNewspaper,
  },
  {
    title: "Stories",
    url: "stories",
    icon: faPaperclip,
  },
  {
    title: "Static Pages",
    url: "static-pages",
    icon: faBook,
  },
];

export default menuItems;



// WEBPACK FOOTER //
// ./src/views/layout/menu-items.js